module.exports = __webpack_public_path__ + "static/media/comdlg32_528.f353d70f.ico";